import { Box, Typography, Autocomplete, TextField } from "@mui/material";
import { SyntheticEvent } from "react";
import { AutocompleteModel, ClientCleaningModel } from "./types";

const CleaningHeader = ({
  data,
  searchValue,
  onAutocompleteChange,
}: {
  data: ClientCleaningModel[] | undefined;
  searchValue: AutocompleteModel | undefined;
  onAutocompleteChange: (
    event: SyntheticEvent,
    newValue: string | AutocompleteModel | null,
  ) => void;
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography component="h2" variant="h6" data-testid="cleaning-data-title">
      Cleaning data
    </Typography>
    <Autocomplete
      disablePortal
      options={
        data?.map(
          (d, index) =>
            ({
              label: d.clientName,
              count: index,
            }) as AutocompleteModel,
        ) ?? []
      }
      onChange={onAutocompleteChange}
      clearOnBlur
      freeSolo
      size="small"
      sx={{ width: 300 }}
      value={searchValue}
      // eslint-disable-next-line react/jsx-props-no-spreading
      renderInput={(params) => <TextField {...params} label="Client search" />}
    />
  </Box>
);

export default CleaningHeader;
